import { useEffect, useState } from 'react';
import useWindowSize from './useWindowSize';

function useBreakpoint() {
  const [breakpoint, setBreakPoint] = useState('');
  const { width } = useWindowSize();
  const siteBreakpoints = window?.ExternalConfig?.breakpoints?.site;

  const breakpoints = {
    375: siteBreakpoints.mobile,
    768: siteBreakpoints.tablet,
    1024: siteBreakpoints.web,
    2560: siteBreakpoints.webLarge,
  };

  useEffect(() => {
    if (width > 0 && width <= 375) {
      setBreakPoint(breakpoints[375]);
    }
    if (width > 375 && width <= 768) {
      setBreakPoint(breakpoints[768]);
    }
    if (width > 768 && width <= 1024) {
      setBreakPoint(breakpoints[1024]);
    }
    if (width > 1024 && width < 2560) {
      setBreakPoint(breakpoints[1024]);
    }
    if (width >= 2560) {
      setBreakPoint(breakpoints[2560]);
    }
  }, [width]);

  return breakpoint;
}

export default useBreakpoint;
